import { render, staticRenderFns } from "./AddBuildingModal.vue?vue&type=template&id=7da9da4c"
import script from "./AddBuildingModal.vue?vue&type=script&lang=js"
export * from "./AddBuildingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports